import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const ConsumerFAQ = () => {
  const { ref, isVisible } = useScrollAnimation();

  const faqs = [
    {
      question: "Is this really free?",
      answer: "Yes, completely free. There are no setup fees, marketing costs, or hidden charges. We offer this service to build relationships with homeowners and connect them with our investor network."
    },
    {
      question: "What's the catch?",
      answer: "There's no catch. We work with real estate investors who buy properties, and you benefit from our extensive buyer network. We make our money when we successfully connect buyers with properties - you pay nothing."
    },
    {
      question: "How quickly can I sell?",
      answer: "It varies by property and price, but many of our buyers are cash investors who can close in as little as 7-30 days. Traditional sales typically take 30-90 days or longer."
    },
    {
      question: "Do I have to accept any offer?",
      answer: "Absolutely not. You're in complete control. We bring you qualified buyers and offers, but you decide which (if any) offers to accept. There's zero pressure and no obligation."
    },
    {
      question: "What information do you need?",
      answer: "Basic property details: address, size, condition, asking price, and your contact information. We'll schedule a brief call to discuss your property and goals."
    },
    {
      question: "Can I still work with a real estate agent?",
      answer: "Yes. Our service complements traditional selling methods. Many homeowners use both approaches to maximize their chances of finding the right buyer."
    }
  ];

  return (
    <section id="faq" ref={ref} className="py-20 px-4 bg-gray-900/30">
      <div className="container mx-auto max-w-4xl">
        <div className={`text-center mb-12 transition-all duration-700 ${isVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          <h2 className="text-4xl font-bold mb-4">Frequently Asked Questions</h2>
          <p className="text-xl text-gray-300">
            Get answers to common questions about our free marketing service
          </p>
        </div>
        
        <div className={`transition-all duration-700 delay-200 ${isVisible ? 'animate-scale-in' : 'opacity-0 scale-95'}`}>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-gray-700"
              >
                <AccordionTrigger className="text-left hover:text-[#ffd700] transition-colors">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default ConsumerFAQ;
